module.exports = __webpack_public_path__ + "static/media/TR.5af98e06.png";